function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Q8el", function(module, exports) {
    $parcel$export(module.exports, "RenderEngagementMessages", ()=>$5c808498c9d51887$export$afddd1e0dec3ab7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fAvyX;
    var $dJl1T;
    var $gG5I6;
    var $5tsrJ;
    var $5eQ1m;
    var $14XJw;
    const $5c808498c9d51887$var$throwError = (message)=>{
        const error = new Error(message);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('engagement-messages.entry', message, error);
        throw error;
    };
    const $5c808498c9d51887$var$getContainer = ()=>{
        let container = document.getElementById('engagement-messages');
        if (container == null) {
            container = document.createElement('div');
            container.id = 'engagement-messages';
            if (document.body) document.body.appendChild(container);
            else $5c808498c9d51887$var$throwError('document.body was not found whilst trying to create the engagement-messages container');
        }
        return container;
    };
    const $5c808498c9d51887$var$GetDom = ()=>{
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gG5I6")).JiraContextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
            orgId: orgId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAvyX")).EngagementMessages), null))));
    };
    const $5c808498c9d51887$export$afddd1e0dec3ab7e = ()=>(0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement($5c808498c9d51887$var$GetDom, null), $5c808498c9d51887$var$getContainer());
    $5c808498c9d51887$export$afddd1e0dec3ab7e();
});
parcelRegister("fAvyX", function(module, exports) {
    $parcel$export(module.exports, "EngagementMessages", ()=>$c086464be6741d59$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dtsBm;
    var $heK1V;
    var $jsNKe;
    class $c086464be6741d59$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsNKe")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heK1V")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dtsBm")).default), null));
        }
    }
});
parcelRegister("dtsBm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0c17e668bd09470$export$2e2bcd8739ae039);
    var $bPTaj;
    var $f9Hff;
    var $mIZkb;
    const $b0c17e668bd09470$export$42b694a35bb75eda = (0, (0, parcelRequire("bPTaj")).default)((0, (0, parcelRequire("mIZkb")).default));
    var $b0c17e668bd09470$export$2e2bcd8739ae039 = (0, (0, parcelRequire("f9Hff")).default)($b0c17e668bd09470$export$42b694a35bb75eda, 'contextualSurvey');
});
parcelRegister("mIZkb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b15ce54686b4a0e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b93Q3;
    var $1gxex;
    var $7Ppa1;
    var $dCQu6;
    function $b15ce54686b4a0e0$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b93Q3")).default), {
            shouldShow: true
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dCQu6")).default), {
                markAsSeenAndFatigued: (0, (0, parcelRequire("1gxex")).markAsSeenAndFatigued),
                sendUserResponse: (0, (0, parcelRequire("1gxex")).sendUserResponse),
                getFlag: (0, (0, parcelRequire("7Ppa1")).getFlag),
                setFlag: (0, (0, parcelRequire("7Ppa1")).setFlag),
                ...props
            }));
    }
});
parcelRegister("b93Q3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c0e849398d4e072$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ahdj0;
    var $k5uoT;
    var $dWO1D;
    const $3c0e849398d4e072$var$animationDuration = 300;
    const $3c0e849398d4e072$var$offscreen = {
        translateX: `${(0, (0, parcelRequire("dWO1D")).surveyInnerWidth) + (0, (0, parcelRequire("dWO1D")).surveyOffset)}px`,
        opacity: '0'
    };
    const $3c0e849398d4e072$var$getAnimationProps = (state)=>{
        switch(state){
            case 'entered':
                return {
                    translateX: '0',
                    opacity: '1'
                };
            case 'entering':
            case 'unmounted':
            case 'exited':
            case 'exiting':
                return $3c0e849398d4e072$var$offscreen;
        }
    };
    function $3c0e849398d4e072$export$2e2bcd8739ae039(props) {
        const { children: children, shouldShow: shouldShow } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ahdj0")).default), {
            in: shouldShow,
            timeout: $3c0e849398d4e072$var$animationDuration,
            unmountOnExit: true
        }, (state)=>{
            const { translateX: translateX, opacity: opacity } = $3c0e849398d4e072$var$getAnimationProps(state);
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("f8Sb3")).css)({
                    position: 'fixed',
                    right: `${(0, (0, parcelRequire("dWO1D")).surveyOffset)}px`,
                    bottom: `${(0, (0, parcelRequire("dWO1D")).surveyOffset)}px`,
                    zIndex: (0, (0, parcelRequire("k5uoT")).layers).flag(),
                    transform: `translateX(${translateX})`,
                    opacity: opacity,
                    transition: `all ${$3c0e849398d4e072$var$animationDuration}ms ease-in-out`,
                    transitionProperty: 'transform, opacity'
                })
            }, children());
        });
    }
});
parcelRegister("dWO1D", function(module, exports) {
    $parcel$export(module.exports, "surveyInnerWidth", ()=>$7fa9f272339c29b6$export$cac609a3cdfd0268);
    $parcel$export(module.exports, "surveyOffset", ()=>$7fa9f272339c29b6$export$d3b22831e495441e);
    var $k5uoT;
    const $7fa9f272339c29b6$export$cac609a3cdfd0268 = (0, (0, parcelRequire("k5uoT")).gridSize)() * 55;
    const $7fa9f272339c29b6$export$d3b22831e495441e = (0, (0, parcelRequire("k5uoT")).gridSize)() * 6;
});
parcelRegister("7Ppa1", function(module, exports) {
    $parcel$export(module.exports, "getFlag", ()=>$b48cfb8c355f77a9$export$a19b74191e00c5e);
    $parcel$export(module.exports, "setFlag", ()=>$b48cfb8c355f77a9$export$5e165df1e30a1331);
    var $M4Zg0 = parcelRequire("M4Zg0");
    var $5Xk79;
    const $b48cfb8c355f77a9$var$hisiGetFlagTemplate = (0, ($parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/hisi/flag{?userKey,flagKey}');
    const $b48cfb8c355f77a9$export$9388e2e6cf5978f0 = '/engage-targeting/api/v2/user/{cloudId}/hisi/flag';
    async function $b48cfb8c355f77a9$export$a19b74191e00c5e(stargateUrl, cloudId, flagKey, userKey) {
        return (0, (0, parcelRequire("5Xk79")).stargateFetch)(`${stargateUrl}${$b48cfb8c355f77a9$var$hisiGetFlagTemplate.expand({
            cloudId: cloudId,
            userKey: userKey,
            flagKey: flagKey
        })}`, {
            method: 'GET'
        }).then((0, (0, parcelRequire("5Xk79")).errorIfNotOk)).then((r)=>r.json());
    }
    async function $b48cfb8c355f77a9$export$5e165df1e30a1331(stargateUrl, cloudId, flagKey, userKey) {
        return (0, (0, parcelRequire("5Xk79")).stargateFetch)(`${stargateUrl}${$b48cfb8c355f77a9$export$9388e2e6cf5978f0}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userKey: userKey,
                flagKey: flagKey
            })
        }).then((0, (0, parcelRequire("5Xk79")).errorIfNotOk)).then((r)=>r).then(()=>Promise.resolve());
    }
});
parcelRegister("dCQu6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35a912cb9dba3799$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3FbOW;
    const $35a912cb9dba3799$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
    class $35a912cb9dba3799$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        firePrimaryClickEvent() {
            this.props.fireClickEvent('primary');
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FbOW")).default), {
                onDismiss: this.onDismiss,
                getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
                onMailingListAnswer: this.onMailingListAnswer,
                onSubmit: this.onSubmit,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.onDismiss = (onDismissArgs)=>{
                const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
                if (onDismissArgs.trigger === (0, (0, parcelRequire("3FbOW")).DismissTrigger).Manual) markAsSeenAndFatigued({
                    stargateUrl: stargateUrl,
                    cloudId: cloudId,
                    messageId: messageId,
                    orgId: orgId,
                    workspaceId: workspaceId
                });
                fireClickEvent('dismiss');
            }, this.getUserHasAnsweredMailingList = async ()=>{
                const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
                try {
                    await getFlag(stargateUrl, cloudId, $35a912cb9dba3799$var$flagKey, aaid);
                    return Promise.resolve(false);
                } catch  {
                    return Promise.resolve(true);
                }
            }, this.onSubmit = async (formValues)=>{
                const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
                const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
                const payload = {
                    responseType: 'ACCEPTANCE_SURVEY',
                    properties: {
                        surveyTimestamp: Date.now(),
                        contextualQuestion: question,
                        contextualStatement: statement,
                        quantitativeResponse: feedbackScore,
                        qualitativeResponse: writtenFeedback,
                        contactable: canContact
                    }
                };
                markAsSeenAndFatigued({
                    stargateUrl: stargateUrl,
                    cloudId: cloudId,
                    messageId: messageId,
                    orgId: orgId,
                    workspaceId: workspaceId
                });
                this.firePrimaryClickEvent();
                return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
            }, this.onMailingListAnswer = async (answer)=>{
                const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
                const payload = {
                    responseType: 'MAILING_LIST_RESPONSE',
                    properties: {}
                };
                setFlag(stargateUrl, cloudId, $35a912cb9dba3799$var$flagKey, aaid);
                if (!answer) return;
                return sendUserResponse(cloudId, stargateUrl, messageId, payload);
            };
        }
    }
});
parcelRegister("3FbOW", function(module, exports) {
    $parcel$export(module.exports, "DismissTrigger", ()=>$9cd0b084ef5c1aee$export$151efc60ac534d42);
    $parcel$export(module.exports, "default", ()=>$9cd0b084ef5c1aee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dFqfg;
    var $3Kxbq;
    var $eUlVw;
    var $5SZ4u;
    var $65zDh;
    var $jXShX;
    var $9cd0b084ef5c1aee$export$151efc60ac534d42;
    (function(DismissTrigger) {
        DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
        DismissTrigger["Manual"] = "MANUAL";
        DismissTrigger["Finished"] = "FINISHED";
        DismissTrigger["Unmount"] = "UNMOUNT";
    })($9cd0b084ef5c1aee$export$151efc60ac534d42 || ($9cd0b084ef5c1aee$export$151efc60ac534d42 = {}));
    const $9cd0b084ef5c1aee$export$3e8963a077f85f25 = 8000;
    var $9cd0b084ef5c1aee$export$2e2bcd8739ae039 = ({ question: question, statement: statement, onDismiss: onDismiss, onSubmit: onSubmit, onMailingListAnswer: onMailingListAnswer, getUserHasAnsweredMailingList: getUserHasAnsweredMailingList, textLabel: textLabel = 'Why did you give that rating', textPlaceholder: textPlaceholder = 'Tell us why' })=>{
        const autoDisappearTimeoutRef = (0, $5uXOq.useRef)(null);
        const isDismissedRef = (0, $5uXOq.useRef)(false);
        const tryDismiss = (0, $5uXOq.useCallback)((trigger)=>{
            if (isDismissedRef.current) return;
            isDismissedRef.current = true;
            onDismissRef.current({
                trigger: trigger
            });
        }, []);
        const [currentStep, setCurrentStep] = (0, $5uXOq.useState)('SURVEY');
        const trySetCurrentStep = (0, $5uXOq.useCallback)((step)=>{
            if (isDismissedRef.current) return;
            setCurrentStep(step);
        }, [
            setCurrentStep
        ]);
        const onDismissRef = (0, $5uXOq.useRef)(onDismiss);
        (0, $5uXOq.useEffect)(()=>{
            onDismissRef.current = onDismiss;
        }, [
            onDismiss
        ]);
        (0, $5uXOq.useEffect)(()=>{
            isDismissedRef.current = false;
        }, []);
        const tryClearTimeout = (0, $5uXOq.useCallback)(()=>{
            const id = autoDisappearTimeoutRef.current;
            if (id) {
                clearTimeout(id);
                autoDisappearTimeoutRef.current = null;
            }
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            return function unmount() {
                tryClearTimeout();
                tryDismiss("UNMOUNT");
            };
        }, [
            tryClearTimeout,
            tryDismiss
        ]);
        const onSurveySubmit = (0, $5uXOq.useCallback)(async (formValues, form, callback = ()=>{})=>{
            await onSubmit(formValues);
            if (isDismissedRef.current) {
                callback();
                return;
            }
            if (!formValues.canContact) {
                callback();
                trySetCurrentStep('POST_SURVEY_NO_CONSENT');
                return;
            }
            const userHasAnswered = await getUserHasAnsweredMailingList();
            callback();
            if (userHasAnswered) {
                trySetCurrentStep('POST_SURVEY_HAS_SIGN_UP');
                return;
            }
            trySetCurrentStep('SIGN_UP_PROMPT');
        }, [
            getUserHasAnsweredMailingList,
            onSubmit,
            trySetCurrentStep
        ]);
        const onMailingListResponse = (0, $5uXOq.useCallback)(async (answer)=>{
            await onMailingListAnswer(answer);
            if (answer) {
                trySetCurrentStep('SIGN_UP_SUCCESS');
                return;
            }
            tryDismiss("FINISHED");
        }, [
            tryDismiss,
            trySetCurrentStep
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isDismissedRef.current) return;
            if (autoDisappearTimeoutRef.current) return;
            if ([
                'SIGN_UP_SUCCESS',
                'POST_SURVEY_NO_CONSENT',
                'POST_SURVEY_HAS_SIGN_UP'
            ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(()=>tryDismiss("AUTO_DISMISS"), $9cd0b084ef5c1aee$export$3e8963a077f85f25);
        }, [
            currentStep,
            tryDismiss
        ]);
        (0, (0, parcelRequire("jXShX")).default)({
            onDismiss: ()=>tryDismiss("MANUAL")
        });
        const content = (()=>{
            if (currentStep === 'SURVEY') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("65zDh")).default), {
                question: question,
                statement: statement,
                textLabel: textLabel,
                textPlaceholder: textPlaceholder,
                onSubmit: onSurveySubmit
            });
            if (currentStep === 'SIGN_UP_PROMPT') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Kxbq")).default), {
                onAnswer: onMailingListResponse
            });
            if (currentStep === 'SIGN_UP_SUCCESS') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eUlVw")).default), null);
            if (currentStep === 'POST_SURVEY_NO_CONSENT' || currentStep === 'POST_SURVEY_HAS_SIGN_UP') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dFqfg")).default), null);
            return null;
        })();
        const manualDismiss = (0, $5uXOq.useCallback)(()=>{
            tryClearTimeout();
            tryDismiss("MANUAL");
        }, [
            tryDismiss,
            tryClearTimeout
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5SZ4u")).default), {
            onDismiss: manualDismiss
        }, content);
    };
});
parcelRegister("dFqfg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d6732b8a4b94e33$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $l1N8i;
    var $1WpT4;
    var $2d6732b8a4b94e33$export$2e2bcd8739ae039 = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1WpT4")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, "Thanks for your feedback"));
});
parcelRegister("1WpT4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f2b3f6433d63bc0$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $c2i4s;
    function $6f2b3f6433d63bc0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $6f2b3f6433d63bc0$var$_ref = {
        name: "12ax6el",
        styles: "position:absolute;top:var(--ds-space-250, 20px);left:var(--ds-space-300, 24px)"
    };
    var $6f2b3f6433d63bc0$var$_ref2 = {
        name: "1byihve",
        styles: "margin-left:var(--ds-space-500, 40px)"
    };
    var $6f2b3f6433d63bc0$export$2e2bcd8739ae039 = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("section", {
            css: $6f2b3f6433d63bc0$var$_ref2
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $6f2b3f6433d63bc0$var$_ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c2i4s"))))), {
            spacing: "spacious",
            label: "",
            "aria-hidden": true,
            color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
            LEGACY_margin: "4px 0 0 0"
        })), children);
});
parcelRegister("c2i4s", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));
    var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
    function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c33b074f80a91d5$var$SuccessIcon = (props)=>$8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
        }, props));
    $8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;
});
parcelRegister("b0JGA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8043220a46fa3485$var$_UNSAFE_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8043220a46fa3485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8043220a46fa3485$var$SuccessIcon = (props)=>$8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;
});
parcelRegister("btivG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $85a0c2d39fdb2976$var$_react = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $85a0c2d39fdb2976$var$_success = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $85a0c2d39fdb2976$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $85a0c2d39fdb2976$var$CheckCircleIcon = (props)=>$85a0c2d39fdb2976$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $85a0c2d39fdb2976$var$_success.default
        }));
    $85a0c2d39fdb2976$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $85a0c2d39fdb2976$var$_default = module.exports.default = $85a0c2d39fdb2976$var$CheckCircleIcon;
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("3Kxbq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3313fdff2243e2f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9yOBd;
    var $l1N8i;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $1WpT4;
    function $3313fdff2243e2f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $3313fdff2243e2f0$var$_ref = {
        name: "15ti532",
        styles: "margin-top:var(--ds-space-400, 32px);display:flex;justify-content:flex-end;& > * + *{margin-left:var(--ds-space-100, 8px);}"
    };
    var $3313fdff2243e2f0$export$2e2bcd8739ae039 = ({ onAnswer: onAnswer })=>{
        const [pending, setPending] = (0, $5uXOq.useState)(null);
        const answeredWith = (0, $5uXOq.useCallback)(async (answer)=>{
            setPending(answer ? 'yes' : 'no');
            await onAnswer(answer);
        }, [
            setPending,
            onAnswer
        ]);
        const isDisabled = Boolean(pending);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1WpT4")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, "Thanks for your feedback"), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlockStart: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, "Are you interested in participating in our research?"), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, "Sign up for the", ' ', (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
            href: "https://www.atlassian.com/research-group"
        }, "Atlassian Research Group"), " and we may contact you in the future with research opportunities."))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3313fdff2243e2f0$var$_ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "subtle",
            onClick: ()=>answeredWith(false),
            isDisabled: isDisabled,
            isLoading: pending === 'no'
        }, "No, thanks"), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "primary",
            onClick: ()=>answeredWith(true),
            isDisabled: isDisabled,
            isLoading: pending === 'yes'
        }, "Yes, sign me up")));
    };
});
parcelRegister("eUlVw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe65693d5d6bd894$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $l1N8i;
    var $luBm6;
    var $cgL5K;
    var $1WpT4;
    var $fe65693d5d6bd894$export$2e2bcd8739ae039 = ({})=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1WpT4")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, "Thanks for signing up"), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, "We may reach out to you in the future to participate in additional research.")));
});
parcelRegister("5SZ4u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bbd778ea09fdd5c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $9yOBd;
    var $84THj;
    var $k5uoT;
    var $dWO1D;
    function $2bbd778ea09fdd5c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $2bbd778ea09fdd5c$var$_ref = {
        name: "1mya5cp",
        styles: "position:absolute;top:var(--ds-space-200, 16px);right:var(--ds-space-200, 16px)"
    };
    var $2bbd778ea09fdd5c$export$2e2bcd8739ae039 = ({ children: children, onDismiss: onDismiss })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                borderRadius: `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`,
                padding: "var(--ds-space-300, 24px)",
                boxShadow: `var(--ds-shadow-overlay, ${`0 20px 32px -8px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
                width: `${(0, (0, parcelRequire("dWO1D")).surveyInnerWidth)}px`
            })
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2bbd778ea09fdd5c$var$_ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
            iconBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                label: "",
                color: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`
            }),
            "aria-label": "Dismiss",
            appearance: "subtle",
            onClick: onDismiss
        })), children);
    };
});
parcelRegister("65zDh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2d340ccfe5ce2f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ahdj0;
    var $2rqOp;
    var $kkJfY;
    var $hp1g9;
    var $efXp3;
    var $7O4UO;
    var $8jRgk;
    var $l1N8i;
    var $luBm6;
    var $cgL5K;
    var $6LCpJ;
    var $k3zvX;
    const $b2d340ccfe5ce2f7$var$getExpandedHeight = (ref, state)=>{
        if (!ref.current) return '0';
        switch(state){
            case 'entering':
                return `${ref.current.scrollHeight}px`;
            case 'entered':
                return `none`;
            default:
                return '0';
        }
    };
    const $b2d340ccfe5ce2f7$var$transitionDuration = 200;
    var $b2d340ccfe5ce2f7$export$2e2bcd8739ae039 = ({ question: question, statement: statement, textPlaceholder: textPlaceholder, textLabel: textLabel, onSubmit: onSubmit })=>{
        const [expanded, setExpanded] = (0, $5uXOq.useState)(false);
        const [canContactDefault, setCanContactDefault] = (0, $5uXOq.useState)(false);
        const hasAutoFilledCanContactRef = (0, $5uXOq.useRef)(false);
        const expandedAreaRef = (0, $5uXOq.useRef)(null);
        const onScoreSelect = (0, $5uXOq.useCallback)(()=>{
            setExpanded(true);
        }, [
            setExpanded
        ]);
        const onFeedbackChange = (0, $5uXOq.useCallback)(()=>{
            if (hasAutoFilledCanContactRef.current) return;
            hasAutoFilledCanContactRef.current = true;
            setCanContactDefault(true);
        }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("section", {
            "aria-labelledby": "contextualSurveyQuestion"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            id: "contextualSurveyQuestion",
            size: "xsmall"
        }, question), statement && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            id: "contextualSurveyStatement"
        }, statement)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("efXp3")).default), {
            onSubmit: onSubmit
        }, ({ formProps: formProps, submitting: submitting })=>(0, (0, parcelRequire("f8Sb3")).jsx)("form", formProps, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7O4UO")).default), {
                name: "feedbackScore",
                isDisabled: submitting,
                isRequired: true
            }, ({ fieldProps: fieldProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k3zvX")).default), {
                    ...fieldProps,
                    onChange: (score)=>{
                        fieldProps.onChange(score);
                        onScoreSelect();
                    }
                })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ahdj0")).default), {
                in: expanded,
                timeout: $b2d340ccfe5ce2f7$var$transitionDuration,
                mountOnEnter: true
            }, (state)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: (0, (0, parcelRequire("f8Sb3")).css)({
                        transition: `max-height ${$b2d340ccfe5ce2f7$var$transitionDuration}ms ease-in-out`,
                        overflow: 'hidden',
                        maxHeight: $b2d340ccfe5ce2f7$var$getExpandedHeight(expandedAreaRef, state)
                    }),
                    ref: expandedAreaRef
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7O4UO")).default), {
                    name: "writtenFeedback",
                    defaultValue: "",
                    isDisabled: submitting
                }, ({ fieldProps: fieldProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6LCpJ")).default), {
                        ...fieldProps,
                        "aria-label": textLabel,
                        placeholder: textPlaceholder,
                        onChange: (event)=>{
                            fieldProps.onChange(event);
                            onFeedbackChange();
                        }
                    })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hp1g9")).default), {
                    name: "canContact",
                    isDisabled: submitting,
                    defaultIsChecked: canContactDefault
                }, ({ fieldProps: fieldProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kkJfY")).default), {
                        ...fieldProps,
                        label: "Atlassian can contact me about this feedback"
                    })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8jRgk")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2rqOp")).default), {
                    type: "submit",
                    appearance: "primary",
                    isLoading: submitting
                }, "Submit")))))));
    };
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    var $VSDnB;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
                fill: "inherit",
                x: "8",
                y: "11",
                width: "8",
                height: "2",
                rx: "1"
            });
        }
        if (isChecked) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
                fill: "inherit"
            });
        }
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("hp1g9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ccbe97401ecc0bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7O4UO;
    const $9ccbe97401ecc0bf$var$CheckboxField = (props)=>{
        const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
        const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
                ...currentValue,
                value
            ] : currentValue, [
            value,
            defaultIsChecked
        ]);
        return value !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            ...rest,
            defaultValue: defaultValue,
            transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                    ...currentValue,
                    value
                ] : currentValue.filter((v)=>v !== value)
        }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            ...rest,
            defaultValue: defaultIsChecked,
            transform: (event)=>event.currentTarget.checked
        }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            }));
    };
    $9ccbe97401ecc0bf$var$CheckboxField.defaultProps = {
        defaultIsChecked: false
    };
    var $9ccbe97401ecc0bf$export$2e2bcd8739ae039 = $9ccbe97401ecc0bf$var$CheckboxField;
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("8jRgk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f31c1f2cf95b88$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $09f31c1f2cf95b88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $09f31c1f2cf95b88$var$formFooterWrapperStyles = {
        name: "1rruhyk",
        styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
    };
    const $09f31c1f2cf95b88$var$justifyContentStyles = {
        name: "11g6mpt",
        styles: "justify-content:flex-start"
    };
    function $09f31c1f2cf95b88$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("footer", {
            css: [
                $09f31c1f2cf95b88$var$formFooterWrapperStyles,
                align === 'start' && $09f31c1f2cf95b88$var$justifyContentStyles
            ]
        }, children);
    }
});
parcelRegister("6LCpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$934f91ac04cc5aeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $1qQmi;
    const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
    const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
    const $934f91ac04cc5aeb$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $934f91ac04cc5aeb$var$packageName,
        packageVersion: $934f91ac04cc5aeb$var$packageVersion
    };
    const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("1qQmi")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $934f91ac04cc5aeb$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1qQmi")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("1qQmi")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $934f91ac04cc5aeb$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
    var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;
});
parcelRegister("1qQmi", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$0f8aaecc0e682a20$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$0f8aaecc0e682a20$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$0f8aaecc0e682a20$export$98856a888ef36079);
    var $f8Sb3;
    var $iaE2J;
    function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0f8aaecc0e682a20$var$disabledRules = {
        backgroundColor: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("iaE2J")).disabledBackground,
        borderColor: (0, parcelRequire("iaE2J")).disabledBorder,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("iaE2J")).disabledTextColor
    };
    const $0f8aaecc0e682a20$var$invalidRules = {
        borderColor: (0, parcelRequire("iaE2J")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover
    };
    const $0f8aaecc0e682a20$var$backgroundColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).subtleBorderColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$lineHeightBase = 20;
    const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
    const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
    const $0f8aaecc0e682a20$var$verticalPadding = 6;
    const $0f8aaecc0e682a20$var$horizontalPadding = 8;
    const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
    const $0f8aaecc0e682a20$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $0f8aaecc0e682a20$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
    const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
        return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
                }
            } : {}
        });
    const $0f8aaecc0e682a20$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("iaE2J")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });
    const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                    borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
                }
            }
        });
    var $0f8aaecc0e682a20$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $0f8aaecc0e682a20$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
        return $0f8aaecc0e682a20$var$_ref;
    };
    const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $0f8aaecc0e682a20$var$codeFontFamily : $0f8aaecc0e682a20$var$fontFamily
        });
    const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
            }
        });
    };
    const $0f8aaecc0e682a20$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$staticStyles, $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), $0f8aaecc0e682a20$var$resizeStyle(resize), $0f8aaecc0e682a20$var$borderStyle(appearance), $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), $0f8aaecc0e682a20$var$placeholderStyles, {
            color: (0, parcelRequire("iaE2J")).textColor,
            '&:disabled': {
                color: $0f8aaecc0e682a20$var$disabledRules.textColor
            }
        });
});
parcelRegister("iaE2J", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$f788b902061573a8$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$f788b902061573a8$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$f788b902061573a8$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$f788b902061573a8$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$f788b902061573a8$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$f788b902061573a8$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$f788b902061573a8$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$f788b902061573a8$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$f788b902061573a8$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$f788b902061573a8$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$f788b902061573a8$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$f788b902061573a8$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$f788b902061573a8$export$f4d082c200a4b4b8);
    const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
    const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
    const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
    const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
    const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
    const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("k3zvX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daaf3c4a3a14eb5e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $9yOBd;
    var $cgL5K;
    var $3bDjY;
    function $daaf3c4a3a14eb5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $daaf3c4a3a14eb5e$var$tooltipMessage = [
        'Strongly disagree',
        'Disagree',
        'Slightly disagree',
        'Neutral',
        'Slightly agree',
        'Agree',
        'Strongly agree'
    ];
    var $daaf3c4a3a14eb5e$var$_ref = {
        name: "1wv0kah",
        styles: "display:flex;margin-top:var(--ds-space-100, 8px);margin-bottom:var(--ds-space-300, 24px);justify-content:space-between;& > span{width:var(--ds-space-1000, 80px);}"
    };
    var $daaf3c4a3a14eb5e$var$_ref2 = {
        name: "qfcj5q",
        styles: "display:flex;justify-content:space-between;& > * + *{margin-left:var(--ds-space-100, 8px);}& > *{flex:1;& > button{justify-content:center;}}"
    };
    var $daaf3c4a3a14eb5e$export$2e2bcd8739ae039 = ({ onChange: onChange, value: value })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $daaf3c4a3a14eb5e$var$_ref2
        }, Array.from({
            length: 7
        }, (_, i)=>{
            const score = i + 1;
            const isSelected = value === score;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                content: $daaf3c4a3a14eb5e$var$tooltipMessage[i],
                key: score,
                hideTooltipOnClick: true
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
                onClick: ()=>onChange(score),
                isSelected: isSelected,
                "aria-pressed": isSelected,
                "aria-describedby": "contextualSurveyStatement",
                "aria-label": $daaf3c4a3a14eb5e$var$tooltipMessage[i],
                shouldFitContainer: true
            }, score));
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $daaf3c4a3a14eb5e$var$_ref,
            "aria-hidden": true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtlest",
            size: "UNSAFE_small",
            weight: "semibold",
            align: "start"
        }, "Strongly disagree"), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtlest",
            size: "UNSAFE_small",
            weight: "semibold",
            align: "center"
        }, "Neutral"), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtlest",
            size: "UNSAFE_small",
            weight: "semibold",
            align: "end"
        }, "Strongly agree")));
});
parcelRegister("jXShX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92496bd6c58ee945$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $92496bd6c58ee945$export$4e7f196112fea3c5 = 27;
    function $92496bd6c58ee945$var$bind(target, eventName, handler, options) {
        target.addEventListener(eventName, handler, options);
        return function unbind() {
            target.removeEventListener(eventName, handler, options);
        };
    }
    function $92496bd6c58ee945$var$shouldDismiss(target) {
        if (!target) return true;
        if (!(target instanceof HTMLElement)) return true;
        if (!target.closest) return false;
        const inTextArea = Boolean(target.closest('textarea'));
        return !inTextArea;
    }
    function $92496bd6c58ee945$export$2e2bcd8739ae039({ onDismiss: onDismiss }) {
        const onDismissRef = (0, $5uXOq.useRef)(onDismiss);
        (0, $5uXOq.useEffect)(()=>{
            onDismissRef.current = onDismiss;
        }, [
            onDismiss
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let unbind;
            function onKeyDown(event) {
                if (event.keyCode !== $92496bd6c58ee945$export$4e7f196112fea3c5) return;
                if (!$92496bd6c58ee945$var$shouldDismiss(event.target)) return;
                if (unbind) unbind();
                onDismissRef.current();
            }
            unbind = $92496bd6c58ee945$var$bind(window, 'keydown', onKeyDown, {
                passive: true
            });
            return unbind;
        }, []);
    }
});
parcelRegister("heK1V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4ee461403acad56$export$2e2bcd8739ae039);
    var $bPTaj;
    var $f9Hff;
    var $aW1yL;
    const $a4ee461403acad56$export$8423d11067fbf579 = (0, (0, parcelRequire("bPTaj")).default)((0, (0, parcelRequire("aW1yL")).default));
    var $a4ee461403acad56$export$2e2bcd8739ae039 = (0, (0, parcelRequire("f9Hff")).default)($a4ee461403acad56$export$8423d11067fbf579, 'flag');
});
parcelRegister("aW1yL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad012ab7963cdddb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $epfFv;
    var $6ARj7;
    var $02CEF;
    var $9pLR7;
    var $7z3TI;
    class $ad012ab7963cdddb$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                fireClickEvent: (0, ($parcel$interopDefault($8Rkzz))),
                primaryText: null,
                primaryAction: null,
                secondaryText: null,
                secondaryAction: null,
                icon: 'smallInfo'
            };
        }
        onClickActionHandler(action) {
            if (action && action.type === (0, (0, parcelRequire("02CEF")).buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
        }
        render() {
            const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
            const actions = [
                {
                    content: primaryText,
                    onClick: this.onPrimaryClick
                }
            ];
            if (secondaryText) actions.push({
                content: secondaryText,
                onClick: this.onSecondaryClick
            });
            const selectedIcon = (0, (0, parcelRequire("7z3TI")).default)[icon];
            const FlagIconComponent = selectedIcon && selectedIcon.component;
            const FlagIcon = FlagIconComponent ? (0, ($parcel$interopDefault($5uXOq))).createElement(FlagIconComponent, {
                label: selectedIcon.label,
                color: selectedIcon.color,
                spacing: "spacious"
            }) : null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ARj7")).default), {
                onDismissed: this.onDismiss
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("epfFv")).default), {
                id: "engagement-flag",
                appearance: "normal",
                icon: FlagIcon,
                title: title,
                description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9pLR7")).default), {
                    html: body
                }),
                actions: actions
            }));
        }
        constructor(...args){
            super(...args), this.onDismiss = ()=>{
                this.props.fireClickEvent('dismiss');
            }, this.onPrimaryClick = ()=>{
                const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
                fireClickEvent('primary');
                this.onClickActionHandler(primaryAction);
            }, this.onSecondaryClick = ()=>{
                const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
                fireClickEvent('secondary');
                this.onClickActionHandler(secondaryAction);
            };
        }
    }
});
parcelRegister("7z3TI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a382696d488f4fda$export$2e2bcd8739ae039);
    var $dp5jO;
    var $729P0;
    var $d4dv2;
    var $dD7Zc;
    var $aEHvW;
    var $96UJI;
    var $1jWct;
    var $bU3PY;
    const $a382696d488f4fda$var$flagMapping = {
        success: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("dp5jO"))))),
            label: 'success',
            color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
        },
        error: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))),
            label: 'error',
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
        },
        info: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("1jWct"))))),
            label: 'info',
            color: `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).T300})`
        },
        warning: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))),
            label: 'warning',
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`
        },
        smallInfo: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("96UJI"))))),
            label: 'info',
            color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P300})`
        },
        comment: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("729P0"))))),
            label: 'comment',
            color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N300})`
        },
        download: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("d4dv2"))))),
            label: 'download',
            color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N300})`
        },
        feedback: {
            component: (0, ($parcel$interopDefault((0, parcelRequire("aEHvW"))))),
            label: 'comment',
            color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N300})`
        }
    };
    var $a382696d488f4fda$export$2e2bcd8739ae039 = $a382696d488f4fda$var$flagMapping;
});
parcelRegister("dp5jO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9c21bc4d0ace2e1e$var$_react = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9c21bc4d0ace2e1e$var$_checkCircle = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("34OIV")));
    var $9c21bc4d0ace2e1e$var$_checkCircle2 = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("btivG")));
    function $9c21bc4d0ace2e1e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9c21bc4d0ace2e1e$var$CheckCircleIcon = (props)=>$9c21bc4d0ace2e1e$var$_react.default.createElement($9c21bc4d0ace2e1e$var$_checkCircle.default, Object.assign({
            LEGACY_fallbackIcon: $9c21bc4d0ace2e1e$var$_checkCircle2.default
        }, props));
    $9c21bc4d0ace2e1e$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
    var $9c21bc4d0ace2e1e$var$_default = module.exports.default = $9c21bc4d0ace2e1e$var$CheckCircleIcon;
});
parcelRegister("34OIV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $23d917767cf5e6f4$var$_UNSAFE_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>$23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
        }, props));
    $23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;
});
parcelRegister("729P0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $51f056b4b27c4a49$var$_react = $51f056b4b27c4a49$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $51f056b4b27c4a49$var$_comment = $51f056b4b27c4a49$var$_interopRequireDefault((parcelRequire("bFmnZ")));
    var $51f056b4b27c4a49$var$_comment2 = $51f056b4b27c4a49$var$_interopRequireDefault((parcelRequire("DBbS0")));
    function $51f056b4b27c4a49$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $51f056b4b27c4a49$var$CommentIcon = (props)=>$51f056b4b27c4a49$var$_react.default.createElement($51f056b4b27c4a49$var$_comment.default, Object.assign({
            LEGACY_fallbackIcon: $51f056b4b27c4a49$var$_comment2.default
        }, props));
    $51f056b4b27c4a49$var$CommentIcon.Name = 'CommentIconMigration';
    var $51f056b4b27c4a49$var$_default = module.exports.default = $51f056b4b27c4a49$var$CommentIcon;
});
parcelRegister("bFmnZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87e4e36d6c115ce9$var$_UNSAFE_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87e4e36d6c115ce9$var$CommentIcon = (props)=>$87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
        }, props));
    $87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
    var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;
});
parcelRegister("DBbS0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $07707de1f3ce8a8c$var$_react = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $07707de1f3ce8a8c$var$_comment = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("bFmnZ")));
    function $07707de1f3ce8a8c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $07707de1f3ce8a8c$var$CommentIcon = (props)=>$07707de1f3ce8a8c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
        }, props, {
            newIcon: $07707de1f3ce8a8c$var$_comment.default
        }));
    $07707de1f3ce8a8c$var$CommentIcon.displayName = 'CommentIcon';
    var $07707de1f3ce8a8c$var$_default = module.exports.default = $07707de1f3ce8a8c$var$CommentIcon;
});
parcelRegister("d4dv2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));
    var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
    function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $98361ed174bfbb2b$var$DownloadIcon = (props)=>$98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
            LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
        }, props));
    $98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
    var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;
});
parcelRegister("EOGIN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $07ab0e2228a1635e$var$_UNSAFE_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $07ab0e2228a1635e$var$DownloadIcon = (props)=>$07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
        }, props));
    $07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
    var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;
});
parcelRegister("5krT5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
    function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3e1473e49ea22b68$var$DownloadIcon = (props)=>$3e1473e49ea22b68$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
        }, props, {
            newIcon: $3e1473e49ea22b68$var$_download.default
        }));
    $3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
    var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;
});
parcelRegister("aEHvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));
    var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
    function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>$7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
            LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
        }, props));
    $7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
    var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("3g1Fk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>$25f4287f17f73dc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
        }, props, {
            newIcon: $25f4287f17f73dc4$var$_feedback.default
        }));
    $25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;
});
parcelRegister("96UJI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6a20af3e274078d5$var$_react = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6a20af3e274078d5$var$_information = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $6a20af3e274078d5$var$_info = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("iRH6p")));
    function $6a20af3e274078d5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6a20af3e274078d5$var$InformationIcon = (props)=>$6a20af3e274078d5$var$_react.default.createElement($6a20af3e274078d5$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $6a20af3e274078d5$var$_info.default
        }, props));
    $6a20af3e274078d5$var$InformationIcon.Name = 'InformationIconMigration';
    var $6a20af3e274078d5$var$_default = module.exports.default = $6a20af3e274078d5$var$InformationIcon;
});
parcelRegister("iRH6p", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $dbbe9c7ad934f1e0$var$_react = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $dbbe9c7ad934f1e0$var$_information = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("2Yv61")));
    function $dbbe9c7ad934f1e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dbbe9c7ad934f1e0$var$EditorInfoIcon = (props)=>$dbbe9c7ad934f1e0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
        }, props, {
            newIcon: $dbbe9c7ad934f1e0$var$_information.default
        }));
    $dbbe9c7ad934f1e0$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
    var $dbbe9c7ad934f1e0$var$_default = module.exports.default = $dbbe9c7ad934f1e0$var$EditorInfoIcon;
});
parcelRegister("1jWct", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
    function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0f64b62884a9bedb$var$InformationIcon = (props)=>$0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
        }, props));
    $0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
    var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;
});
parcelRegister("jsNKe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83cedfa423052192$export$2e2bcd8739ae039);
    var $bPTaj;
    var $f9Hff;
    var $jen8y;
    const $83cedfa423052192$export$404a075b2b026e91 = (0, (0, parcelRequire("bPTaj")).default)((0, (0, parcelRequire("jen8y")).default));
    var $83cedfa423052192$export$2e2bcd8739ae039 = (0, (0, parcelRequire("f9Hff")).default)($83cedfa423052192$export$404a075b2b026e91, 'modalDialog');
});
parcelRegister("jen8y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$800dae19672b9473$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $evqT3;
    var $02CEF;
    var $9pLR7;
    function $800dae19672b9473$var$header() {
        return null;
    }
    class $800dae19672b9473$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        getActionButton(action, text, onClick) {
            return {
                text: text,
                onClick: (e)=>{
                    if (action.type === (0, (0, parcelRequire("02CEF")).buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                    onClick(e);
                }
            };
        }
        getActions() {
            const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
            const actions = [];
            if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
            if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
            return actions;
        }
        getAdditionalModalProps() {
            const props = {};
            const { imageSrc: imageSrc } = this.props;
            if (imageSrc) props.image = imageSrc;
            else props.header = $800dae19672b9473$var$header;
            return props;
        }
        render() {
            const { title: title, body: body } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("evqT3")).default), {
                actions: this.getActions(),
                heading: title,
                ...this.getAdditionalModalProps()
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9pLR7")).default), {
                html: body
            }));
        }
        constructor(...args){
            super(...args), this.onPrimaryAction = ()=>{
                this.props.fireClickEvent('primary');
            }, this.onSecondaryAction = ()=>{
                this.props.fireClickEvent('secondary');
            };
        }
    }
});
parcelRegister("evqT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44afc303b109e730$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9yOBd;
    var $dkK4L;
    var $1R1Ge;
    var $7QSqG;
    var $kdO7l;
    var $jSZUh;
    var $lPfex;
    class $44afc303b109e730$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
            const Header = this.headerComponent(this.props);
            const Footer = this.footerComponent(this.props);
            const CustomHeader = ()=>{
                const { titleId: titleId } = (0, (0, parcelRequire("kdO7l")).useModal)();
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalHeading), {
                    id: titleId
                }, heading);
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldCloseOnEscapePress: false,
                shouldCloseOnOverlayClick: false,
                shouldScrollInViewport: true,
                experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
                footer: footer,
                header: header,
                heading: heading,
                image: image,
                ...rest
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Header, null), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7QSqG")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalBody), null, heading && (0, (0, parcelRequire("f8Sb3")).jsx)(CustomHeader, null), children)), (0, (0, parcelRequire("f8Sb3")).jsx)(Footer, null));
        }
        constructor(...args){
            super(...args), this.headerComponent = (props)=>{
                const { header: HeaderElement, image: src } = props;
                const ImageElement = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalImage), {
                        src: src,
                        alt: ""
                    });
                return HeaderElement || ImageElement;
            }, this.footerComponent = (props)=>{
                const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
                const ActionsElement = ()=>actionList ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dkK4L")).default).Provider, {
                        value: (0, (0, parcelRequire("lPfex")).modalButtonTheme)
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                    }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                        const variant = idx ? 'subtle-link' : 'primary';
                        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalActionItem), {
                            key: key || (typeof text === 'string' ? text : `${idx}`)
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
                            appearance: variant,
                            autoFocus: !idx,
                            ...rest
                        }, text));
                    }))) : null;
                return FooterElement || ActionsElement;
            };
        }
    }
});
parcelRegister("jSZUh", function(module, exports) {
    $parcel$export(module.exports, "ModalBody", ()=>$1c1428422690040b$export$cb540d8b0ef7906c);
    $parcel$export(module.exports, "ModalHeading", ()=>$1c1428422690040b$export$9af27c346834c182);
    $parcel$export(module.exports, "ModalImage", ()=>$1c1428422690040b$export$1355685fd5f8d257);
    $parcel$export(module.exports, "ModalActionContainer", ()=>$1c1428422690040b$export$633dda6b40ac1ac3);
    $parcel$export(module.exports, "ModalActionItem", ()=>$1c1428422690040b$export$c245e9f76e3299b1);
    var $f8Sb3;
    var $3RZIb;
    function $1c1428422690040b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1c1428422690040b$var$modalBodyStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-500, 40px)"} ${"var(--ds-space-200, 16px)"}`,
        textAlign: 'center'
    });
    const $1c1428422690040b$var$modalHeadingStyles = (0, (0, parcelRequire("f8Sb3")).css)([
        (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("3RZIb")).h600)({
            theme: {
                mode: 'light'
            }
        })),
        {
            marginBottom: "var(--ds-space-100, 8px)",
            color: 'inherit'
        }
    ]);
    const $1c1428422690040b$var$modalImageStyles = {
        name: "1e6i37z",
        styles: "width:100%;height:auto;border-start-end-radius:var(--ds-border-radius, 3px);border-start-start-radius:var(--ds-border-radius, 3px);@media (min-width: 320px) and (max-width: 480px){border-radius:0;}"
    };
    const $1c1428422690040b$var$modalActionContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-500, 40px)"} 36px`,
        justifyContent: 'center',
        flexDirection: 'row',
        flexFlow: 'wrap'
    });
    const $1c1428422690040b$var$modalActionContainerReversedStyles = {
        name: "2b8jyz",
        styles: "flex-direction:row-reverse"
    };
    const $1c1428422690040b$var$modalActionItemStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $1c1428422690040b$export$cb540d8b0ef7906c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1c1428422690040b$var$modalBodyStyles
        }, children);
    const $1c1428422690040b$export$9af27c346834c182 = ({ children: children, id: id })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: $1c1428422690040b$var$modalHeadingStyles,
            id: id
        }, children);
    };
    const $1c1428422690040b$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>(0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            css: $1c1428422690040b$var$modalImageStyles,
            alt: alt,
            src: src
        });
    const $1c1428422690040b$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1c1428422690040b$var$modalActionContainerStyles,
                shouldReverseButtonOrder && $1c1428422690040b$var$modalActionContainerReversedStyles
            ]
        }, children);
    const $1c1428422690040b$export$c245e9f76e3299b1 = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1c1428422690040b$var$modalActionItemStyles
        }, children);
});
